import React from 'react';
import clsx from 'clsx';
import { connect } from 'react-redux';
import { firstErrorMessage } from '@/utils/errors';
import Filter from '@/components/Filter';
import { fetchCollections, updateCollectionsFilter } from '../actions';

const CollectionsFilters = ({
  category,
  className,
  fetchData,
  filterTerm,
  fluid,
  readErrors,
  updateFilterTerm,
}) => (
  <Filter
    fluid={fluid}
    className={clsx('aridhia-collections-filter', className)}
    filterTerm={filterTerm}
    updateFilter={({ value }) => updateFilterTerm(category, value)}
    error={firstErrorMessage(readErrors)}
    onFilter={() => fetchData(category, 1)}
  />
);

const mapStateToProps = ({
  collections: { collections },
}, { category }) => {
  const item = collections[category];

  return (
    {
      filterTerm: item.filter,
      readErrors: item.readErrors,
    }
  );
};

const mapDispatchToProps = {
  updateFilterTerm: updateCollectionsFilter,
  fetchData: fetchCollections,
};

export default connect(mapStateToProps, mapDispatchToProps)(CollectionsFilters);
